<template>
  <div id="body_PD" v-if="allBetEvent.od[plytyp]">
    <!------------------------ FT CS ------------------------>
    <template v-for="btype in btypes" v-if="allBetEvent.od[plytyp][btype]">
        <table id="model_PD" border="0" cellpadding="0" cellspacing="0" class="more_table2">
          <tbody>
            <!--tr style="height:2px"><td class="emptyrow" :class="{isrb: allBetEvent.event_rb==1}"  colspan="16"></td></tr-->
            <template v-for="(subMatch, subMatchKey) in (allBetEvent.sub + 1)">
              <tr v-if="subMatchKey == 0">
                <th class="more_title4" colspan="16" @click="showLeg()">
                  <button id="triggertoggle" class="trigger toggle-primary" :class="show ? 'icon-open' : 'icon-close'"></button>

                  <span class="btheader">{{ sportAllBetLang['ALL_BET.SUBHEADER_CS'] }}</span>
                  <span class="more_og2" v-if="plytyp==firstHtPlyType">&nbsp;{{ sportAllBetLang['ALL_BET.SUBHEADER_1HT'] }}</span>
                  <span class="more_og2" v-if="isSpecial">&nbsp;({{ sportAllBetLang['ALL_BET.LBL_SPECIALS'] }})</span>

                  <!-- <span class="more_star_bg" v-if="!myMarket" @click="addToMyMarket(plytyp,btype)">
                    <span id="star_R" name="star_R" class="star_down" :title="sportAllBetLang['ALL_BET.MSG_CLICK_ADD_TO_MYMARKET']"></span>
                  </span>
                  <span class="more_star_bg" v-else @click="removeFromMyMarket(plytyp,btype)">
                    <span id="star_R" name="star_R" class="star_up" :title="sportAllBetLang['ALL_BET.MSG_CLICK_ADD_TO_MYMARKET']"></span>
                  </span> -->
                </th>
              </tr>
              <template v-if="show">
              <template v-if="subMatchKey == 0">
                <!-- <tr class="more_white">
                  <td colspan="2" class="game_team"><span>{{ allBetEvent.tacapt }}</span></td>
                  <td colspan="1" class="game_team"><span>{{ sportAllBetLang['ALL_BET.LBL_DRAW'] }}</span></td>
                  <td colspan="2" class="game_team"><span>{{ allBetEvent.tbcapt }}</span></td>
                </tr> -->
                <tr>
                  <th class="allbetheader csheader" title="1 - 0"><span>1 - 0</span></th>
                  <th class="allbetheader csheader" title="2 - 0"><span>2 - 0</span></th>
                  <th class="allbetheader csheader" title="2 - 1"><span>2 - 1</span></th>
                  <th class="allbetheader csheader" title="3 - 0"><span>3 - 0</span></th>
                  <th class="allbetheader csheader" title="3 - 1"><span>3 - 1</span></th>
                  <th class="allbetheader csheader" title="3 - 2"><span>3 - 2</span></th>
                  <template v-if="plytyp=='1'">
                    <th class="allbetheader csheader"  title="2 - 0"><span>4 - 0</span></th>
                    <th class="allbetheader csheader"  title="4 - 1"><span>4 - 1</span></th>
                    <th class="allbetheader csheader"  title="4 - 2"><span>4 - 2</span></th>
                    <th class="allbetheader csheader"  title="4 - 4"><span>4 - 3</span></th>
                  </template>
                  <th class="allbetheader csheader"  title="0 - 0"><span>0 - 0</span></th>
                  <th class="allbetheader csheader"  title="1 - 1"><span>1 - 1</span></th>
                  <th class="allbetheader csheader"  title="2 - 2"><span>2 - 2</span></th>
                  <th class="allbetheader csheader"  title="3 - 3"><span>3 - 3</span></th>
                  <template v-if="plytyp=='1'">
                    <th class="allbetheader csheader"  title="4 - 4"><span>4 - 4</span></th>
                  </template>
                  <th class="allbetheader csheader" :title="sportAllBetLang['ALL_BET.LBL_AOS']"><span>{{ sportAllBetLang['ALL_BET.LBL_AOS_SHORT'] }}</span></th>
                </tr>

                <tr>
                  <td colspan="16" style="padding-left:0px;padding-right: 0px">
                    <table border="0" cellpadding="0" cellspacing="0">
                      <tr>
                        <td class="cursorcontent allbetcontent abcs"  :class="{isrb: allBetEvent.event_rb==1}" @click="selectCell($event,'teamod10')">
                          <div class="betArea abcs">
                            <cstgftht :event="allBetEvent" :score="'od10'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod10"/>
                          </div>
                        </td>
                        <td class="cursorcontent allbetcontent abcs"  :class="{isrb: allBetEvent.event_rb==1}" @click="selectCell($event,'teamod20')">
                          <div class="betArea abcs">
                            <cstgftht :event="allBetEvent" :score="'od20'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod20"/>
                          </div>
                        </td>
                        <td class="cursorcontent allbetcontent abcs"  :class="{isrb: allBetEvent.event_rb==1}" @click="selectCell($event,'teamod21')"> 
                          <div class="betArea abcs">
                            <cstgftht :event="allBetEvent" :score="'od21'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod21"/>
                          </div>
                        </td>
                        <td class="cursorcontent allbetcontent abcs"  :class="{isrb: allBetEvent.event_rb==1}" @click="selectCell($event,'teamod30')">
                          <div class="betArea abcs">
                            <cstgftht :event="allBetEvent" :score="'od30'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod30"/>
                          </div>
                        </td>
                        <td class="cursorcontent allbetcontent abcs"  :class="{isrb: allBetEvent.event_rb==1}" @click="selectCell($event,'teamod31')">
                          <div class="betArea abcs">
                            <cstgftht :event="allBetEvent" :score="'od31'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod31"/>
                          </div>
                        </td> 
                        <td class="cursorcontent allbetcontent abcs"  :class="{isrb: allBetEvent.event_rb==1}" @click="selectCell($event,'teamod32')">
                          <div class="betArea abcs">
                            <cstgftht :event="allBetEvent" :score="'od32'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod32"/>
                          </div>
                        </td>
                        <template v-if="plytyp=='1'">
                        <td class="cursorcontent allbetcontent abcs"  :class="{isrb: allBetEvent.event_rb==1}" @click="selectCell($event,'teamod40')">
                          <div class="betArea abcs">
                            <cstgftht :event="allBetEvent" :score="'od40'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod40"/>
                          </div>
                        </td>
                        <td class="cursorcontent allbetcontent abcs"  :class="{isrb: allBetEvent.event_rb==1}" @click="selectCell($event,'teamod41')">
                          <div class="betArea abcs">
                            <cstgftht :event="allBetEvent" :score="'od41'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod41"/>
                          </div>
                        </td>
                        <td class="cursorcontent allbetcontent abcs"  :class="{isrb: allBetEvent.event_rb==1}" @click="selectCell($event,'teamod42')">
                          <div class="betArea abcs">
                            <cstgftht :event="allBetEvent" :score="'od42'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod42"/>
                          </div>
                        </td>
                        <td class="cursorcontent allbetcontent abcs"  :class="{isrb: allBetEvent.event_rb==1}" @click="selectCell($event,'teamod43')">
                          <div class="betArea abcs">
                            <cstgftht :event="allBetEvent" :score="'od43'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod43"/>
                          </div>
                        </td>
                        </template>
                        <td class="cursorcontent allbetcontent abcs" rowspan="2"  :class="{isrb: allBetEvent.event_rb==1}" @click="selectCell($event,'teamod00')">
                          <div class="betArea abcs">
                            <cstgftht :event="allBetEvent" :score="'od00'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod00"/>
                          </div>
                        </td>
                        <td class="cursorcontent allbetcontent abcs" rowspan="2"  :class="{isrb: allBetEvent.event_rb==1}" @click="selectCell($event,'teamod11')">
                          <div class="betArea abcs">
                            <cstgftht :event="allBetEvent" :score="'od11'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod11"/>
                          </div>
                        </td>
                        <td class="cursorcontent allbetcontent abcs" rowspan="2"  :class="{isrb: allBetEvent.event_rb==1}" @click="selectCell($event,'teamod22')">
                          <div class="betArea abcs">
                            <cstgftht :event="allBetEvent" :score="'od22'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod22"/>
                          </div>
                        </td>
                        <td class="cursorcontent allbetcontent abcs" rowspan="2"  :class="{isrb: allBetEvent.event_rb==1}" @click="selectCell($event,'teamod33')">
                          <div class="betArea abcs">
                            <cstgftht :event="allBetEvent" :score="'od33'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod33"/>
                          </div>
                        </td>
                        <template v-if="plytyp=='1'">
                        <td class="cursorcontent allbetcontent abcs" rowspan="2"  :class="{isrb: allBetEvent.event_rb==1}" @click="selectCell($event,'teamod44')">
                          <div class="betArea abcs">
                            <cstgftht :event="allBetEvent" :score="'od44'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod44"/>
                          </div>
                        </td>
                        </template>
                        <td class="cursorcontent allbetcontent abcs" rowspan="2" :class="{['AOS'+plytyp]: true, isrb: (allBetEvent.event_rb==1)}" @click="selectCell($event,'teamodaos')">
                          <div class="betArea abcs">
                            <cstgftht :event="allBetEvent" :score="'aos'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamodaos"/>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="cursorcontent allbetcontent abcs"  :class="{isrb: allBetEvent.event_rb==1}" @click="selectCell($event,'teamod01')">
                          <div class="betArea abcs">
                            <cstgftht :event="allBetEvent" :score="'od01'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod01"/>
                          </div>
                        </td>
                        <td class="cursorcontent allbetcontent abcs"  :class="{isrb: allBetEvent.event_rb==1}" @click="selectCell($event,'teamod02')">
                          <div class="betArea abcs">
                            <cstgftht :event="allBetEvent" :score="'od02'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod02"/>
                          </div>
                        </td>
                        <td class="cursorcontent allbetcontent abcs"  :class="{isrb: allBetEvent.event_rb==1}" @click="selectCell($event,'teamod12')">
                          <div class="betArea abcs">
                            <cstgftht :event="allBetEvent" :score="'od12'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod12"/>
                          </div>
                        </td>
                        <td class="cursorcontent allbetcontent abcs"  :class="{isrb: allBetEvent.event_rb==1}" @click="selectCell($event,'teamod03')">
                          <div class="betArea abcs">
                            <cstgftht :event="allBetEvent" :score="'od03'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod03"/>
                          </div>
                        </td>
                        <td class="cursorcontent allbetcontent abcs"  :class="{isrb: allBetEvent.event_rb==1}" @click="selectCell($event,'teamod13')">
                          <div class="betArea abcs">
                            <cstgftht :event="allBetEvent" :score="'od13'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod13"/>
                          </div>
                        </td>
                        <td class="cursorcontent allbetcontent abcs"  :class="{isrb: allBetEvent.event_rb==1}" @click="selectCell($event,'teamod23')">
                          <div class="betArea abcs">
                            <cstgftht :event="allBetEvent" :score="'od23'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod23"/>
                          </div>
                        </td>
                        <template v-if="plytyp=='1'">
                        <td class="cursorcontent allbetcontent abcs"  :class="{isrb: allBetEvent.event_rb==1}" @click="selectCell($event,'teamod04')">
                          <div class="betArea abcs">
                            <cstgftht :event="allBetEvent" :score="'od04'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod04"/>
                          </div>
                        </td>
                        <td class="cursorcontent allbetcontent abcs"  :class="{isrb: allBetEvent.event_rb==1}" @click="selectCell($event,'teamod14')"> 
                          <div class="betArea abcs">
                            <cstgftht :event="allBetEvent" :score="'od14'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod14"/>
                          </div>
                        </td>
                        <td class="cursorcontent allbetcontent abcs"  :class="{isrb: allBetEvent.event_rb==1}" @click="selectCell($event,'teamod24')">
                          <div class="betArea abcs">
                            <cstgftht :event="allBetEvent" :score="'od24'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod24"/>
                          </div>
                        </td>
                        <td class="cursorcontent allbetcontent abcs"  :class="{isrb: allBetEvent.event_rb==1}" @click="selectCell($event,'teamod34')">
                          <div class="betArea abcs">
                            <cstgftht :event="allBetEvent" :score="'od34'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod34"/>
                          </div>
                        </td>
                        </template>
                      </tr>
                    </table>
                  </td>
                </tr>
              </template>
              </template>
            </template>
          </tbody>
        </table>
    </template>
  </div>
</template>

<script>

  import OddComponents from '../../../components/odd'
  import HandicapComponents from '../../../components/handicap'

  import allBetMixin from '../../../mixins/allBet'

  export default {
    mixins: [allBetMixin],
    props: {
      allBetEvent : null,
      plytyp: null,
      selectMarket: null,
      removeMarket: null,
      rbinfo: null,
      myMarket: {
        type: Boolean,
        default: false
      },
      isSpecial: {
        type: Boolean,
        default: false
      },
    },
    data() {
        return {
            btypes: [allBetMixin.data().csBetType, allBetMixin.data().rcsBetType],
            show: true,
        }
    },
    methods: {
      showLeg() {
        this.show = (!this.show) ? true : false;
      },
      addToMyMarket(plytyp,csBetType) {
        if(this.selectMarket)
          this.selectMarket(this.allBetEvent, plytyp, csBetType, this.isSpecial)
      },
      removeFromMyMarket(plytyp,csBetType) {
        if(this.removeMarket)
          this.removeMarket(this.allBetEvent, plytyp, csBetType, this.isSpecial)
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/allBet/fullTime-cs.vue